module.exports = __webpack_public_path__ + "static/media/arrow-forward-white.d2e283ea.svg";